const CONSTANTS = {
  SET_LANGUAGE: "SET_LANGUAGE",
  SET_SIDEBAR_OPEN: "SET_SIDEBAR_OPEN",
  TOGGLE_SIDEBAR_OPEN: "TOGGLE_SIDEBAR_OPEN",
  RESET_COMMON: "RESET_COMMON",
  SET_API_CALL_EXECUTED: "SET_API_CALL_EXECUTED",
  ADD_ADDITIONAL_TRANSLATIONS: "ADD_ADDITIONAL_TRANSLATIONS",
  MODULE_LOADED: "MODULE_LOADED",

  // user agreement
  GET_USER_AGREEMENT: "CC_LAYOUT_GET_USER_AGREEMENT",
  GET_USER_AGREEMENT_BY_ID: "CC_LAYOUT_GET_USER_AGREEMENT_BY_ID",
  SET_USER_AGREEMENT: "CC_LAYOUT_SET_USER_AGREEMENT",
  SET_USER_AGREEMENT_BY_ID: "CC_LAYOUT_SET_USER_AGREEMENT_BY_ID",
  SET_CONTRACTS_MODAL_IS_OPEN: "CC_LAYOUT_SET_CONTRACTS_MODAL_IS_OPEN",
  SET_SELECTED_AGREEMENT: "CC_LAYOUT_SET_SELECTED_AGREEMENT",

  GET_NOTIFICATIONS: "GET_NOTIFICATIONS",
  SET_NOTIFICATIONS: "SET_NOTIFICATIONS",
  READ_NOTIFICATION: "READ_NOTIFICATION",
  SET_NOTIFICATIONS_OPEN: "SET_NOTIFICATIONS_OPEN",
  GET_ALL_NOTIFICATIONS: "GET_ALL_NOTIFICATIONS",
  SET_ALL_NOTIFICATIONS: "SET_ALL_NOTIFICATIONS",
  SET_ALL_NOTIFICATIONS_OPEN: "SET_ALL_NOTIFICATIONS_OPEN",
  RECEIVE_NOTIFICATIONS: "RECEIVE_NOTIFICATIONS",
  SET_WEBSOCKET_CONNECTED: "SET_WEBSOCKET_CONNECTED",
  SET_DOWNLOAD_DOCUMENT_LOADING: "SET_DOWNLOAD_DOCUMENT_LOADING",

  GET_DOWNLOAD_DOCUMENT: "GET_DOWNLOAD_DOCUMENT",

  GET_LEGAL_INFO_DOC_TITLES: "GET_LEGAL_INFO_DOC_TITLES",
  SET_LEGAL_INFO_DOC_TITLES: "SET_LEGAL_INFO_DOC_TITLES",
};

export default CONSTANTS;
